import { lookupMessage } from "./dictionary.js";
export var Locale;
(function (Locale) {
    Locale["ca"] = "ca";
    Locale["de"] = "de";
    Locale["en"] = "en";
    Locale["es"] = "es";
    Locale["fr"] = "fr";
    Locale["it"] = "it";
    Locale["nl"] = "nl";
    Locale["pt"] = "pt";
})(Locale || (Locale = {}));
export const translate = (translations, locale, defaultLocale = Locale.en, takeFirst = true) => {
    const locales = locale ? locale.pop ? locale : [locale] : [];
    if (defaultLocale)
        locales.push(defaultLocale);
    if (takeFirst)
        locales.push(Object.keys(translations)[0]);
    let translation = locales.reduce((trans, locale) => {
        if (!trans && translations[locale]) {
            return {
                text: translations[locale],
                locale: locale,
            };
        }
        return trans;
    }, undefined);
    return translation;
};
export const getTextFromTranslatable = (translatable, locale, defaultLocale = Locale.en, takeFirst = true) => {
    if (translatable) {
        if (typeof translatable === 'string') {
            return translatable;
        }
        else {
            const translation = translate(translatable, locale, defaultLocale, takeFirst);
            return translation ? translation.text : undefined;
        }
    }
    else {
        return undefined;
    }
};
export const getText = (texts, locale, dictionary, notFound) => {
    let text = undefined;
    if (texts) {
        if (texts.text || texts.key) {
            //texts is TextOrLookup
            if (typeof texts.text) {
                text = getTextFromTranslatable(texts.text, locale);
            }
            if (!text && texts.key) {
                text = lookupMessage(texts.key, dictionary, undefined);
            }
        }
        else {
            text = getTextFromTranslatable(texts, locale);
        }
    }
    if (text) {
        return text;
    }
    else {
        if (typeof notFound === 'string') {
            return notFound;
        }
        else {
            throw new Error('Text not found.');
        }
    }
};
const getParentLanguage = (language) => {
    let i = language.indexOf('-');
    if (i == -1) {
        i = language.indexOf('_');
    }
    return i > 0 ? language.substring(0, i) : undefined;
};
export const toLocale = (language) => {
    let locale = Locale[language];
    if (!locale) {
        const parent = getParentLanguage(language);
        if (parent) {
            locale = Locale[parent];
        }
        if (!locale) {
            locale = Locale.en;
        }
    }
    return locale;
};
